import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardHeader, CardTitle, CardContent } from '../../ui/card'
import { Badge } from '../../ui/badge'
import { Calendar, CheckCircle2 } from 'lucide-react'

function EnrolledClasses({ klassPackages, currentSkillLevelName }) {
  const maxVisibleClasses = 2
  const visibleClasses = klassPackages?.slice(0, maxVisibleClasses) || []
  const additionalCount = (klassPackages?.length || 0) - maxVisibleClasses

  if (!klassPackages || klassPackages.length === 0) {
    return (
      <Card className="h-full">
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <Calendar className="w-5 h-5 text-blue-600" />
            Enrolled Classes
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-gray-600">Not currently enrolled in any classes.</p>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card className="h-full">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <Calendar className="w-5 h-5 text-blue-600" />
          Enrolled Classes
        </CardTitle>
        <p className="text-sm text-gray-600 mt-1">{currentSkillLevelName} level</p>
      </CardHeader>
      <CardContent className="space-y-3">
        {visibleClasses.map((klassPackage) => (
          <div
            key={klassPackage.id}
            className="bg-white rounded-lg p-3 border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-gray-900 text-sm mb-1">{klassPackage.title}</h3>
                {klassPackage.description && (
                  <p className="text-xs text-gray-600 line-clamp-2">{klassPackage.description}</p>
                )}
              </div>
              <Badge className="bg-blue-600 hover:bg-blue-700 flex-shrink-0 text-xs">
                <CheckCircle2 className="w-3 h-3 mr-1" />
                Active
              </Badge>
            </div>
          </div>
        ))}

        {additionalCount > 0 && (
          <div className="text-center py-2 px-3 bg-gray-50 rounded-lg border border-gray-200">
            <p className="text-sm font-medium text-gray-700">
              + {additionalCount} more {additionalCount === 1 ? 'class' : 'classes'}
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  )
}

EnrolledClasses.propTypes = {
  klassPackages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  ),
  currentSkillLevelName: PropTypes.string.isRequired
}

export default EnrolledClasses
